(function(){
  'use strict';
  var money=function(c){
    try{
      var f=(window.Shopify&&window.Shopify.money_format)||'{{amount}}';
      var n=(c/100).toFixed(f.indexOf('no_decimals')>-1?0:2);
      var p=n.split('.');
      p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,',');
      return f.replace(/\{\{\s*\w+\s*\}\}/,p.join('.'));
    }catch(e){return c;}
  };
  window.orviMoney=money;

  /* Scroll reveal */
  function reveal(root){
    var els=(root||document).querySelectorAll('.orvi-reveal:not(.is-in)');
    if(!els.length)return;
    if(!('IntersectionObserver'in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(en){
      en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}});
    },{rootMargin:'0px 0px -8% 0px',threshold:.08});
    els.forEach(function(e){io.observe(e);});
  }

  /* Accordions */
  function accordions(root){
    (root||document).querySelectorAll('[data-orvi-acc]:not([data-bound])').forEach(function(b){
      b.setAttribute('data-bound','1');
      b.addEventListener('click',function(){
        var panel=document.getElementById(b.getAttribute('aria-controls'));
        var open=b.getAttribute('aria-expanded')==='true';
        b.setAttribute('aria-expanded',String(!open));
        if(panel)panel.setAttribute('data-open',String(!open));
      });
    });
  }

  /* Anchor tabs */
  function tabs(root){
    (root||document).querySelectorAll('[data-orvi-scrollto]:not([data-bound])').forEach(function(a){
      a.setAttribute('data-bound','1');
      a.addEventListener('click',function(e){
        var t=document.getElementById(a.getAttribute('data-orvi-scrollto'));
        if(!t)return;
        e.preventDefault();
        t.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });
  }

  /* Quantity steppers */
  function qty(root){
    (root||document).querySelectorAll('[data-orvi-qty]:not([data-bound])').forEach(function(w){
      w.setAttribute('data-bound','1');
      var input=w.querySelector('input');
      w.addEventListener('click',function(e){
        var b=e.target.closest('[data-step]');
        if(!b||!input)return;
        var min=parseInt(input.min||'1',10);
        var v=parseInt(input.value||'1',10)+parseInt(b.getAttribute('data-step'),10);
        input.value=String(Math.max(min,v));
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
    });
  }

  /* Product gallery */
  function gallery(root){
    (root||document).querySelectorAll('[data-orvi-gallery]:not([data-bound])').forEach(function(g){
      g.setAttribute('data-bound','1');
      var track=g.querySelector('[data-track]');
      var thumbs=g.querySelectorAll('[data-thumb]');
      var dots=g.querySelectorAll('[data-dot]');
      if(!track)return;
      function mark(i){
        thumbs.forEach(function(t,n){t.setAttribute('aria-current',String(n===i));});
        dots.forEach(function(d,n){d.setAttribute('aria-current',String(n===i));});
      }
      function go(i){
        var slide=track.children[i];
        if(slide)track.scrollTo({left:slide.offsetLeft,behavior:'smooth'});
        mark(i);
      }
      thumbs.forEach(function(t,i){t.addEventListener('click',function(){go(i);});});
      dots.forEach(function(d,i){d.addEventListener('click',function(){go(i);});});
      var raf;
      track.addEventListener('scroll',function(){
        cancelAnimationFrame(raf);
        raf=requestAnimationFrame(function(){
          mark(Math.round(track.scrollLeft/Math.max(1,track.clientWidth)));
        });
      },{passive:true});
      /* Desktop hover zoom */
      track.querySelectorAll('[data-zoom]').forEach(function(z){
        z.addEventListener('mousemove',function(e){
          if(window.matchMedia('(hover:none)').matches)return;
          var r=z.getBoundingClientRect();
          var img=z.querySelector('img');
          if(!img)return;
          img.style.transformOrigin=((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
          img.style.transform='scale(1.7)';
        });
        z.addEventListener('mouseleave',function(){
          var img=z.querySelector('img');
          if(img){img.style.transform='';}
        });
      });
      mark(0);
    });
  }

  /* Sticky mobile buy bar */
  function stickyBar(root){
    (root||document).querySelectorAll('[data-orvi-sticky]:not([data-bound])').forEach(function(bar){
      bar.setAttribute('data-bound','1');
      var sentinel=document.getElementById(bar.getAttribute('data-sentinel')||'');
      if(!sentinel||!('IntersectionObserver'in window))return;
      new IntersectionObserver(function(en){
        bar.setAttribute('data-visible',String(!en[0].isIntersecting&&en[0].boundingClientRect.top<0));
      },{threshold:0}).observe(sentinel);
    });
  }

  /* Bundle selector */
  function bundles(root){
    (root||document).querySelectorAll('[data-orvi-bundle]:not([data-bound])').forEach(function(b){
      b.setAttribute('data-bound','1');
      var opts=b.querySelectorAll('[data-bundle-opt]');
      var btn=b.querySelector('[data-bundle-add]');
      var out=b.querySelector('[data-bundle-total]');
      function sel(o){
        opts.forEach(function(x){x.setAttribute('aria-checked',String(x===o));});
        if(out&&o.getAttribute('data-price'))out.textContent=money(parseInt(o.getAttribute('data-price'),10));
        if(btn){
          btn.setAttribute('data-variant',o.getAttribute('data-variant')||'');
          btn.setAttribute('data-qty',o.getAttribute('data-qty')||'1');
          btn.disabled=!o.getAttribute('data-variant');
        }
      }
      opts.forEach(function(o){
        o.addEventListener('click',function(){sel(o);});
        o.addEventListener('keydown',function(e){if(e.key===' '||e.key==='Enter'){e.preventDefault();sel(o);}});
      });
      var pre=b.querySelector('[data-bundle-opt][data-default]')||opts[0];
      if(pre)sel(pre);
    });
  }

  /* Add to cart via Shopify AJAX API */
  function addToCart(root){
    (root||document).querySelectorAll('[data-orvi-add]:not([data-bound])').forEach(function(btn){
      btn.setAttribute('data-bound','1');
      btn.addEventListener('click',function(e){
        var id=btn.getAttribute('data-variant');
        if(!id)return;
        e.preventDefault();
        var label=btn.querySelector('[data-label]')||btn;
        var original=label.textContent;
        btn.disabled=true;label.textContent='Adding…';
        fetch(window.Shopify.routes.root+'cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id:Number(id),quantity:Number(btn.getAttribute('data-qty')||1)}]})
        }).then(function(r){return r.json();}).then(function(){
          label.textContent='Added ✓';
          document.dispatchEvent(new CustomEvent('cart:update',{detail:{source:'orvi'}}));
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
          var opener=document.querySelector('cart-drawer-component,[data-cart-drawer-open],#cart-drawer');
          if(opener&&typeof opener.open==='function'){try{opener.open();}catch(err){}}
          setTimeout(function(){label.textContent=original;btn.disabled=false;},1800);
        }).catch(function(){
          label.textContent=original;btn.disabled=false;
        });
      });
    });
  }

  function init(root){
    reveal(root);accordions(root);tabs(root);qty(root);
    gallery(root);stickyBar(root);bundles(root);addToCart(root);
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){init(document);});
  }else{init(document);}
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();